import { useQuery } from '@tanstack/react-query'
import { statisticsApi } from '@api/endpoints/statistics'
import { DayRange } from '@api/types/dashboard'

export function useDashboardStatistics(days: DayRange) {
  return useQuery({
    queryKey: ['dashboard-statistics', days],
    queryFn: () => statisticsApi.getDashboard({ days }),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  })
}
